<template>
  <div>
    <div v-if="tengxunDetailId===0">
      <div class="tengxunDetail_num">
        <div class="tengxunDetail_inputname">会员类型:</div>
        <input placeholder="请选择类型" class="tengxunDetail_numinput" disabled="disabled" :value="QQvipname" />
        <img src="/static/xiangxia1.png" class="tengxunDetail_xiangxiapicker" @click="tengxunDetailvip()" />
      </div>
      <div class="tengxunDetail_num">
        <div class="tengxunDetail_inputname">QQ号码:</div>
        <input placeholder="请输入QQ号码" class="tengxunDetail_numinput" type="number" />
      </div>
      <!-- <div class="tengxunDetail_tip">温馨提示:请认真核对QQ号，对个人输入有误产生的售后问题概不受理</div> -->
      <div class="tengxunDetail_text">会员套餐</div>
      <div class="tengxunDetail_chongzhiList">
        <div :class="item.selectQQ? 'tengxunDetail_chongzhibox1' : 'tengxunDetail_chongzhibox'" v-for="(item,index) in tengxunQQvipDetail.detailkind"
          @click="changeQQkind(index)">
          <div class="tengxunDetail_price">{{item.price}}</div>
          <div class="tengxunDetail_kind">{{item.kind}}</div>
        </div>
      </div>
      <div class="tengxunDetail_chongzhibutton">立即充值</div>
      <p v-if="qqvipselect">
        <van-picker show-toolbar :columns="QQvipKind" @cancel="onCancel" @confirm="onConfirm" />
      </p>
    </div>
    <div v-else-if="tengxunDetailId===1">
      <div class="tengxunDetail_num">
        <div class="tengxunDetail_inputname">QQ号码:</div>
        <input placeholder="请输入QQ号码" class="tengxunDetail_numinput" type="number" />
      </div>
      <!-- <div class="tengxunDetail_tip">温馨提示:请认真核对QQ号，对个人输入有误产生的售后问题概不受理</div> -->
      <div class="tengxunDetail_text">Q币套餐</div>
      <div class="tengxunDetail_chongzhiList">
        <div :class="item.selectQbi ? 'tengxunDetail_chongzhibox1' : 'tengxunDetail_chongzhibox' " v-for="(item,index) in tengxunQbiDetail.Qbidetailkind"
          @click="changeQbikind(index)">
          <div class="tengxunDetail_price">{{item.price}}</div>
          <div class="tengxunDetail_kind">{{item.num}}</div>
        </div>
      </div>
      <div class="tengxunDetail_num" v-if="tengxunDetailIndex===4">
        <div class="tengxunDetail_inputname">其他数量:</div>
        <input placeholder="请输入充值数量" class="tengxunDetail_numinput" type="number" />
      </div>
      <div class="tengxunDetail_chongzhibutton">立即充值</div>
    </div>
    <div v-else>
      <div class="tengxunDetail_num">
        <div class="tengxunDetail_inputname">QQ号码:</div>
        <input placeholder="请输入QQ号码" class="tengxunDetail_numinput" type="number" />
      </div>
      <div class="tengxunDetail_num" v-if="tengxunDetailId!=3">
        <div class="tengxunDetail_inputname">大区:</div>
        <input placeholder="请选择大区" class="tengxunDetail_numinput" disabled="disabled" :value="QQdaquname" />
        <img src="/static/xiangxia1.png" class="tengxunDetail_xiangxiapicker" @click="tengxunDetaildaqu()" />
      </div>
      <!-- <div class="tengxunDetail_tip">温馨提示:请认真核对QQ号，对个人输入有误产生的售后问题概不受理</div> -->
      <div class="tengxunDetail_text">会员套餐</div>
      <div class="tengxunDetail_chongzhiList">
        <div :class="item.selectgame? 'tengxunDetail_chongzhibox1' : 'tengxunDetail_chongzhibox'" v-for="(item,index) in tengxunGameDetail.gamekind"
          @click="changeGamekind(index)">
          <div class="tengxunDetail_price">{{item.price}}</div>
          <div class="tengxunDetail_kind">{{item.num}}</div>
        </div>
      </div>
      <div class="tengxunDetail_num" v-if="tengxungameIndex===4">
        <div class="tengxunDetail_inputname">其他数量:</div>
        <input placeholder="请输入充值数量" class="tengxunDetail_numinput" type="number" />
      </div>
      <div class="tengxunDetail_chongzhibutton">立即充值</div>
      <p v-if="daquselect">
        <van-picker show-toolbar :columns="QQdaquKind" @cancel="onCancel1" @confirm="onConfirm1" />
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        QQvipKind: ["QQ会员", "超级会员", "其他会员"],//QQ会员充值picker
        QQdaquKind: ['皮城警备 电信', '征服之海 电信', '守望之海 电信', '卡拉曼达 电信', '均衡教派 电信', '水晶之痕 电信'],//英雄联盟大区picker
        qqvipselect: false,//QQ会员选择下拉
        QQvipname: "",//QQ会员选择类型名
        //QQ会员类型详情内容
        tengxunQQvipDetail: {
          name: "",
          detailkind: [{
            price: "10元",
            kind: "一个月",
            selectQQ: false
          }, {
            price: "30元",
            kind: "三个月",
            selectQQ: false
          }, {
            price: "120元",
            kind: "一年",
            selectQQ: false
          }]
        },
        tengxunDetailId: 0,//腾讯列表穿来的id值
        //Q币类型详情内容
        tengxunQbiDetail: {
          name: "",
          Qbidetailkind: [{
            price: "10元",
            num: "10个",
            selectQbi: false
          }, {
            price: "30元",
            num: "30个",
            selectQbi: false
          }, {
            price: "50元",
            num: "50个",
            selectQbi: false
          }, {
            price: "100元",
            num: "100个",
            selectQbi: false
          }, {
            price: "自定义",
            num: "",
            selectQbi: false
          }],
        },
        tengxunDetailIndex: 0, //自定义类型索引
        daquselect: false,
        QQdaquname: "",
        tengxunGameDetail: {
          name: "",
          gamekind: [{
            price: "10元",
            num: "10个",
            selectgame: false
          }, {
            price: "30元",
            num: "30个",
            selectgame: false
          }, {
            price: "50元",
            num: "50个",
            selectgame: false
          }, {
            price: "100元",
            num: "100个",
            selectgame: false
          }, {
            price: "自定义",
            num: "",
            selectgame: false
          }]
        },
        tengxungameIndex: 0
      }
    },
    created() {
      if (this.$route.query.tengxunDetailId != 'undefined') {
        this.tengxunDetailId = this.$route.query.tengxunDetailId
        let that = this
        // that.videoDetail = that.videoDetailList[Number(this.tengxunDetailId)]
        // that.videoname = that.videoDetail.name
        // console.log("videoDetail", that.videoDetail)
      }
    },
    mounted() {

    },
    methods: {
      tengxunDetailvip() {
        this.qqvipselect = true
      },
      onConfirm(value, index) {
        this.qqvipselect = false
        this.QQvipname = value

      },
      onCancel() {
        this.qqvipselect = false
      },
      changeQbikind(e) {
        let that = this
        that.tengxunDetailIndex = Number(e)
        let tengxunQbiDetail = that.tengxunQbiDetail
        tengxunQbiDetail.Qbidetailkind.map((item, index) => item.selectQbi = index === Number(e))
      },
      changeQQkind(e) {
        let that = this
        let tengxunQQvipDetail = that.tengxunQQvipDetail
        tengxunQQvipDetail.detailkind.map((item, index) => item.selectQQ = index === Number(e))
      },
      changeGamekind(e) {
        let that = this
        that.tengxungameIndex = Number(e)
        let tengxunGameDetail = that.tengxunGameDetail
        tengxunGameDetail.gamekind.map((item, index) => item.selectgame = index === Number(e))
      },
      tengxunDetaildaqu() {
        this.daquselect = true
      },
      onConfirm1(value, index) {
        this.daquselect = false
        this.QQdaquname = value

      },
      onCancel1() {
        this.daquselect = false
      },
    }
  }
</script>

<style>
  .tengxunDetail_num {
    display: flex;
    /*    justify-content: center; */
    align-items: center;
    margin: 20px;
  }

  .tengxunDetail_inputname {
    margin-right: 15px;
    width: 70px;
  }

  input {
    border: none;
    outline: none;
  }

  input::-webkit-input-placeholder {
    text-align: center;
    color: #dedede;
  }

  input[disabled] {
    filter: alpha(opacity=100);
    opacity: 1;
    background: #fff;
  }

  .tengxunDetail_numinput {
    height: 30px;
    width: 220px;
    border-bottom: 1px solid #dedede;
  }

  .tengxunDetail_xiangxiapicker {
    width: 40px;
    height: 40px;
  }

  .van-picker {
    position: absolute;
    bottom: 0;
    width: 100%;
  }

  .tengxunDetail_tip {
    margin: 10px 20px;
    color: red;

  }

  .tengxunDetail_text {
    margin: 50px 20px 20px 20px;
    font-size: 17px;
    font-weight: 600;
  }

  .tengxunDetail_chongzhiList {
    margin: 20px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .tengxunDetail_chongzhibox {
    height: 80px;
    border: 1px solid #dedede;
    padding: 20px;
    margin: 10px;
    width: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .tengxunDetail_chongzhibox1 {
    height: 80px;
    border: 1px solid #1b91ec;
    padding: 20px;
    margin: 10px;
    width: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #1b91ec;
  }

  .tengxunDetail_price {
    margin-bottom: 20px;
  }

  .tengxunDetail_kind {}

  .tengxunDetail_chongzhibutton {
    margin: 20px 50px;
    height: 50px;
    width: 75%;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #1b91ec;
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/pages/tengxun/tengxunDetail.vue